export default __webpack_public_path__ + "static/media/sectores_10.bc27f8a4.png";